import { Identifiable, Status } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateTaskStatus(httpClient: HttpClient) {
  return (status: Identifiable<Status>, nextStatus: Status) =>
    httpClient.sendHttpRequest<Identifiable<Status>>({
      endpoint: `/statuses/${status.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        ...nextStatus,
        percentComplete: nextStatus.percentComplete ?? null,
      },
    });
}

export { updateTaskStatus };
